import React from "react";
import UserDetails from "@components/userComponents/UserDetails";
import FeedTab from "@components/feedComponents/FeedTab";

export default function Feed({
  user,
  setShareLinksModal,
  userFeedData,
  userLikesFeedData,
}) {
  return (
    <div className="w-full min-h-screen">
      <UserDetails user={user} setShareLinksModal={setShareLinksModal} />
      <FeedTab
        userFeedData={userFeedData}
        userLikesFeedData={userLikesFeedData}
        user={user}
      />
    </div>
  );
}
